import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        
        let moduleEl = this.el;
        let moduleId = moduleEl.getAttribute('data-mid');

        let tooltips = moduleEl.querySelectorAll('span[class*="ttp__tooltip--"]');

        tooltips.forEach(tooltip => {
            if(tooltip.previousElementSibling.classList.contains('ttp__tooltip') === true) {
                tooltip.previousElementSibling.classList.add('ttp__trigger' + moduleId);
                tooltip.previousElementSibling.setAttribute('tabindex', '0');
                tooltip.previousElementSibling.appendChild(tooltip);
            }
        });
    }
}
